import NumberFlow from '@number-flow/react'
import { useEffect, useState } from 'react'

type AnimatedCurrencyProps = {
  value?: number | null;
  className?: string;
  'aria-hidden'?: boolean;
}

export function AnimatedCurrency ({
  value,
  className,
  ...rest
}: AnimatedCurrencyProps) {
  const [animatedValue, setAnimatedValue] = useState<number | null>(null)
  const [showPlaceholder, setShowPlaceholder] = useState(true)

  useEffect(() => {
    if (value == null) {
      // Animate to 0 before showing placeholder
      if (animatedValue != null && animatedValue !== 0) {
        setAnimatedValue(0)

        const timeout = setTimeout(() => {
          setAnimatedValue(null)
          setShowPlaceholder(true)
        }, 300) // delay long enough to show 0 animation

        return () => clearTimeout(timeout)
      }

      // If already null or 0, just show placeholder
      setAnimatedValue(null)
      setShowPlaceholder(true)
    } else {
      // From null → animate from 0 → value
      setAnimatedValue(0)
      setShowPlaceholder(false)

      const timeout = setTimeout(() => {
        setAnimatedValue(value)
      }, 10)

      return () => clearTimeout(timeout)
    }
  }, [value])

  if (animatedValue == null && showPlaceholder) {
    return (
      <span className={className}>
        $<span className='font-mono'>-.--</span>
      </span>
    )
  }

  return (
    <NumberFlow
      {...rest}
      className={className}
      value={animatedValue ?? 0}
      format={{
        style: 'currency',
        currency: 'USD',
      }}
    />
  )
}
